import { toast } from 'react-toastify';

import { getSerializedErrorMessage } from '../../../../../utils/errors';
import { decrementPendingGeneralInfoUpdates } from '../../../utils';

import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import type { IIntakeQuestionnaireGeneralInfo, IntakeQuestionnaireState } from '../../types';
import type { IntakeGeneralThunks, UpdateIntakeGeneralInfoPayload } from './types';

export function addIntakeGeneralCases(
  builder: ActionReducerMapBuilder<IntakeQuestionnaireState>,
  thunks: IntakeGeneralThunks,
) {
  addUpdateIntakeGeneralInfoCases(builder, thunks);
}

function addUpdateIntakeGeneralInfoCases(
  builder: ActionReducerMapBuilder<IntakeQuestionnaireState>,
  thunks: IntakeGeneralThunks,
) {
  const { updateIntakeGeneralInfo } = thunks;

  builder
    .addCase(updateIntakeGeneralInfo.pending, (state) => {
      state.pendingGeneralInfoUpdateCount += 1;
      state.updateGeneralInfoLoading = true;
      state.error = null;
    })
    .addCase(
      updateIntakeGeneralInfo.fulfilled,
      (
        state,
        action: PayloadAction<
          IIntakeQuestionnaireGeneralInfo,
          string,
          { arg: UpdateIntakeGeneralInfoPayload }
        >,
      ) => {
        decrementPendingGeneralInfoUpdates(state);
        if (!state.intakeQuestionnaireDetails) return;
        // Merge only the fields that this PATCH actually changed. Each blur-save
        // sends a single field, so applying just that field keeps an out-of-order
        // (older) response from clobbering a newer value on a different field.
        const { general_info } = state.intakeQuestionnaireDetails;
        if (general_info) {
          Object.assign(general_info, action.meta.arg.data);
        } else {
          state.intakeQuestionnaireDetails.general_info = action.payload;
        }
      },
    )
    .addCase(updateIntakeGeneralInfo.rejected, (state, action) => {
      decrementPendingGeneralInfoUpdates(state);
      state.error = action.error;
      toast.error(getSerializedErrorMessage(action.error));
    });
}
